import { Navbar, Container, Nav } from 'react-bootstrap';
import logo from '../../images/logo.png';
import './navegation.css';

const Navegation = () => {
  return (
    <div>
        <Navbar collapseOnSelect expand="lg"  variant="dark" id='nav'>
            <Container>
                <Navbar.Brand id='logobrand' href='/'>
                  <img src={logo} alt="" />
                </Navbar.Brand>              
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto">
                </Nav>
                <Nav>
                    <Nav.Link id='link' href='/'>Home</Nav.Link>                                    
                    <Nav.Link id='link' href='/cardapio'>Cardápio</Nav.Link>                                    
                    <Nav.Link id='link' href='/contato'>Contato</Nav.Link>                                    
                </Nav>
            </Navbar.Collapse>
            </Container>
        </Navbar>
    </div>
  )
}

export default Navegation